/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React, { useState, useEffect } from "react";
import { Navbar } from "../Navigation/Navbar";
import { IntegrationUpload } from "./IntegrationUpload";
import { useSelector } from "react-redux";
import { HelpButton } from "../Common/HelpButton"

// import { Footer } from './Footer';
import {
  Tabs,
  Segmented
} from "antd";

import "../../Styles/styles-UploadData.css";

const { TabPane } = Tabs;

export const UploadData = (props) => {
  const {
    info: {
      integrations: integrations,
    },
  } = useSelector(({ team }) => team);

  const [activeTab, setActiveTab] = useState("");
  const [paneData, setPaneData] = useState({});
  const [providersByIntegration, setProvidersByIntegration] = useState({});
  const [segmentOptions, setSegmentOptions] = useState([]);

  useEffect(() => {
    if (integrations !== undefined) {
      let providersByIntegrationObj = {};
      let api_csv_integration = {};
      let type = "";
      let value = "";
      for (const [key, values] of Object.entries(integrations)) {
        for (let i = 0; i < values.length; i++) {
          value = values[i];
          type = value.type;
          let valueKey = value?.key;

          if (!valueKey) continue;
          
          if (type in api_csv_integration) {
            api_csv_integration[type].push(value);
          } else {
            api_csv_integration[type] = [value];
          }

          if (key in providersByIntegrationObj) {
            if (!providersByIntegrationObj[key]?.includes(value.key)) {
              providersByIntegrationObj[key] = [...providersByIntegrationObj[key], value.key]
            }
          } else {
            providersByIntegrationObj[key] = [value.key]
          }
        }
      }
      setProvidersByIntegration(providersByIntegrationObj);

      let integration_keys = Object.keys(api_csv_integration);
      let segmentOps = [];
      for (let i = 0; i < integration_keys.length; i++) 
        segmentOps.push({ label: integration_keys[i].toUpperCase(), value: integration_keys[i]});
      
      setSegmentOptions(segmentOps);
      setPaneData(api_csv_integration);
      if (segmentOps.length > 0) {
        setActiveTab(segmentOps[0].value);
      }

      
    }
  }, [integrations]);

  return (
    <>
      <HelpButton page="Upload" />
      <Navbar />
      <div className="postdata-content">
        <div className="search-divider"></div>
      </div>

      <div className="segmented-container">
        <Segmented
          value={activeTab}
          onChange={(value) => setActiveTab(value)}
          options={segmentOptions}
          style={{marginBottom: '1vh'}}
        />
        {
          paneData && (
            <IntegrationUpload 
              dataProviders={paneData[activeTab]} 
              tabType={activeTab}
              activeTab={activeTab}
              providersByIntegration={providersByIntegration}
            />
          )
        }
      </div>
      
      {/* <Footer style={{color: 'grey', marginTop:'70px'}}>GPS DataViz 2021</Footer> */}
    </>
  );
}